import React from 'react';
import { Box, Typography, Container, Grid } from '@mui/material';
import PropertyCard from '../../components/property/PropertyCard';

const SavedPropertiesPage = () => {
  // In a real application, this would fetch saved properties from an API
  const savedProperties = []; // Empty for now until we implement the saved properties feature

  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Typography variant="h4" component="h1" gutterBottom>
        Saved Properties
      </Typography>
      
      {savedProperties.length === 0 ? (
        <Box sx={{ textAlign: 'center', py: 8 }}>
          <Typography variant="h6" color="text.secondary">
            You haven't saved any properties yet.
          </Typography>
          <Typography color="text.secondary">
            When you find a property you like, click the heart icon to save it for later.
          </Typography>
        </Box>
      ) : (
        <Grid container spacing={3}>
          {savedProperties.map((property) => (
            <Grid item xs={12} sm={6} md={4} key={property.id}>
              <PropertyCard property={property} />
            </Grid>
          ))}
        </Grid>
      )}
    </Container>
  );
};

export default SavedPropertiesPage;